import { Box, Typography } from "@mui/material"
import { format, isValid } from "date-fns"
import Iconify from "minimals-template/components/Iconify"

export function SentToLegacyBanner({ sentToLegacy, sentBy }) {
    const timestamp = formatTimestamp(sentToLegacy)
    const attribution = sentBy ? ` by ${sentBy}` : ""
    const lead = timestamp ? `Sent to legacy on ${timestamp}${attribution}.` : "Sent to legacy."

    return (
        <Box
            data-cy="sent-to-legacy-banner"
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                px: 2,
                py: 1.25,
                borderRadius: 1,
                bgcolor: "info.lighter",
                color: "info.darker",
            }}
        >
            <Iconify icon="material-symbols:lock-outline" width={20} />
            <Typography variant="body2">
                <Typography component="span" sx={{ fontWeight: 700 }}>
                    {lead}
                </Typography>{" "}
                Editing is disabled.
            </Typography>
        </Box>
    )
}

function formatTimestamp(value) {
    if (!value) return null
    const date = new Date(value)
    if (!isValid(date)) return null
    return format(date, "d MMM yyyy 'at' h:mmaaa")
}
